import { userLogin } from "~/composables/useLogin";
import { abortNavigation, navigateTo } from "nuxt/app";
import { matchneedLoginPath, routeProcessingDuringTest } from "~/utils/route";
import { useAccountStore } from "~/store/account";
import { storeToRefs } from "pinia";

export default defineNuxtRouteMiddleware((to, from) => {
  const router = useRouter();
  if (process.server) return;
  const accountStore = useAccountStore();
  const { access_token } = storeToRefs(accountStore);
  const toLoginWithPath = accountStore.toLoginWithPath;
  // 已登录, 没必要让用户跳转登录页面;
  if (!!~to.path.indexOf("/account") && !!access_token.value) {
    console.log("replace");
    router.replace("/");
  }
  // 路由跳转登录防护;
  if (!access_token.value) {
    // 内测期间必须登录
    routeProcessingDuringTest(String(to.name));
    if (matchneedLoginPath(to.name)) {
      // 直接通过浏览器url地址访问;
      if (from.name === to.name) {
        return toLoginWithPath(to.path);
      } else {
        return userLogin()
          .then(() => navigateTo("/account/register"))
          .catch((err) => {
            if (err === "close") return abortNavigation();
            if (err === "cancel") return toLoginWithPath(to.path);
          });
      }
    }
  }
});
